import Everyone from 'components/common/icons/Everyone'
import HiRepIcon from 'components/common/icons/PracticeGuidelines/HiRepIcon'
import useRolePermissions from 'hooks/useRolePermissions'
import { UserNoteVisiblities } from 'logic/patientNotesLogic'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default ({ onVisibilitySelected = () => {}, currentNoteVisibility }) => {
  const { t } = useTranslation()
  const { permissions } = useRolePermissions()

  const getNoteVisibilityLabel = useCallback(
    visibility =>
      t(`dialogs.notes.visibileFor`, {
        visibility: t(`dialogs.notes.visibilityOptions.${visibility || 'public'}`)
      }),
    [t]
  )

  const visibilityOptions = useMemo(() => {
    const options = [
      {
        id: 'public',
        value: UserNoteVisiblities.Public,
        icon: <Everyone />,
        condition: true
      },
      {
        id: 'HI',
        value: UserNoteVisiblities.HI,
        icon: <HiRepIcon color="black" width={16} height={20} />,
        condition: permissions.notes.visibilityOptions.hi
      }
    ]
      .filter(option => option.condition)
      .map(option => ({
        ...option,
        selected: currentNoteVisibility === option.value,
        label: getNoteVisibilityLabel(option.id),
        onClick: () => onVisibilitySelected(option.value)
      }))

    if (options.length <= 1) {
      return []
    }

    return options
  }, [currentNoteVisibility, permissions, onVisibilitySelected, getNoteVisibilityLabel])

  const hasAnyVisibilityOption = useMemo(() => visibilityOptions.length > 0, [visibilityOptions])

  const currentVisibilityLabel = useMemo(
    () => getNoteVisibilityLabel(currentNoteVisibility),
    [currentNoteVisibility, getNoteVisibilityLabel]
  )

  return {
    visibilityOptions,
    hasAnyVisibilityOption,
    currentVisibilityLabel
  }
}
